import { defineMessages } from "react-intl";

export const giftCardListSearchAndFiltersMessages = defineMessages({
  searchPlaceholder: {
    id: "jY80Gs",
    defaultMessage: "Search by code, e.g {exampleGiftCardCode}",
    description: "search gift card placeholder",
  },
  defaultTabLabel: {
    id: "tTuCYj",
    defaultMessage: "All Gift Cards",
    description: "all gift cards label",
  },
});
